import React from 'react';

export default function HintError({ errors, refComp }) {
    if (errors !== undefined && errors !== []) {
        //console.log('styles: ', refComp.current.style);
        return errors.map((er, index) => {
            //refComp.current.style.border = "2px solid red"
            if(er.slug){
                return <span style={{ color: "red" }} key={index}>{er.slug}</span>
            }
            else{
                return <span style={{ color: "red" }} key={index}>{er}</span>
            }
        })
    }
    else return '';
}